import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon, Button } from '@gisatcz/ptr-atoms';
import './style.scss';
import images from './images';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SimpleLayersControl = function SimpleLayersControl(_ref) {
  var onSelect = _ref.onSelect,
    opensRight = _ref.opensRight,
    opensBottom = _ref.opensBottom,
    left = _ref.left,
    top = _ref.top,
    right = _ref.right,
    bottom = _ref.bottom,
    layerTemplates = _ref.layerTemplates,
    activeLayerTemplateKey = _ref.activeLayerTemplateKey,
    onMount = _ref.onMount;
  var wrapperEl = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  useEffect(function () {
    if (typeof onMount === 'function') {
      onMount();
    }
  }, []);
  var close = function close() {
    setIsOpen(false);
  };
  var open = function open() {
    setIsOpen(true);
  };
  var handleClickOutside = function handleClickOutside() {
    if (isOpen) {
      close();
    }
  };
  useOnClickOutside(wrapperEl, handleClickOutside);
  var onControlButtonClick = function onControlButtonClick() {
    if (isOpen) {
      close();
    } else {
      open();
    }
  };
  var onLayerTileClick = function onLayerTileClick(key) {
    if (onSelect) {
      onSelect(key);
    }
  };
  var renderMenu = function renderMenu() {
    var tileWidth = 7;
    var tileHeight = 5;
    var tileMargin = 0.25;
    var contentMargin = 1;
    if (layerTemplates) {
      var grid = getGrid(layerTemplates.length);
      var menuClasses = classnames('ptr-simple-layers-control-menu', {
        open: isOpen,
        right: opensRight,
        left: !opensRight,
        bottom: opensBottom
      });
      var menuStyle = {
        width: isOpen ? "".concat((tileWidth + 2 * tileMargin) * grid.width + 2 * contentMargin, "rem") : 0,
        height: isOpen ? "".concat((tileHeight + 2 * tileMargin) * grid.height + 2 * contentMargin, "rem") : '2rem'
      };
      var contentStyle = {
        margin: "".concat(contentMargin, "rem"),
        width: "calc(100% - ".concat(2 * contentMargin, "rem)"),
        height: "calc(100% - ".concat(2 * contentMargin, "rem)")
      };
      return /*#__PURE__*/_jsx("div", {
        className: menuClasses,
        style: menuStyle,
        children: /*#__PURE__*/_jsx("div", {
          className: "ptr-simple-layers-control-menu-content",
          style: contentStyle,
          children: layerTemplates.map(function (layerTemplate) {
            return renderTile(layerTemplate, tileWidth, tileHeight, tileMargin);
          })
        })
      });
    } else {
      return null;
    }
  };
  var renderTile = function renderTile(layerTemplate, width, height, margin) {
    var _layerTemplate$data;
    var active = layerTemplate.key === activeLayerTemplateKey;
    var classes = classnames('ptr-simple-layers-control-tile', {
      active: active
    });
    var style = {
      width: "".concat(width, "rem"),
      height: "".concat(height, "rem"),
      margin: "".concat(margin, "rem")
    };
    var previewParam = {};
    if (layerTemplate !== null && layerTemplate !== void 0 && (_layerTemplate$data = layerTemplate.data) !== null && _layerTemplate$data !== void 0 && _layerTemplate$data.thumbnail && Object.hasOwn(images, layerTemplate.data.thumbnail)) {
      var image = images[layerTemplate.data.thumbnail];
      if (_typeof(image) === 'object') {
        previewParam['src'] = images[layerTemplate.data.thumbnail]["default"];
      } else {
        previewParam['src'] = images[layerTemplate.data.thumbnail];
      }
      previewParam['alt'] = layerTemplate.data.thumbnail;
    } else {
      previewParam['src'] = images.noPreview;
      previewParam['alt'] = 'thumbnail';
    }
    return /*#__PURE__*/_jsxs("div", {
      style: style,
      className: classes,
      onClick: function onClick() {
        return onLayerTileClick(layerTemplate.key);
      },
      children: [/*#__PURE__*/_jsx("img", {
        className: "ptr-simple-layers-control-tile-preview",
        src: previewParam.src,
        alt: previewParam.alt,
        style: {
          height: "".concat(height - 1.5, "rem"),
          margin: "0 ".concat(margin, "rem 0 ").concat(margin, "rem")
        }
      }), /*#__PURE__*/_jsx("label", {
        className: "ptr-simple-layers-control-tile-name",
        title: layerTemplate.data.nameDisplay,
        children: layerTemplate.data.nameDisplay
      })]
    }, layerTemplate.key);
  };
  var getGrid = function getGrid(count) {
    var width = 1;
    var height = 1;

    // TODO solve 9+ cases
    if (count >= 7) {
      width = 3;
      height = 3;
    } else if (count >= 5) {
      width = 2;
      height = 3;
    } else if (count === 4) {
      width = 2;
      height = 2;
    } else if (count === 3) {
      height = 3;
    } else if (count === 2) {
      height = 2;
    }
    return {
      width: width,
      height: height
    };
  };
  var buttonClasses = classnames('ptr-simple-layers-control control', {
    open: isOpen
  });
  var style = {
    left: "".concat(left ? "".concat(left, "rem") : undefined),
    top: "".concat(top ? "".concat(top, "rem") : undefined),
    right: "".concat(right ? right : 0.5, "rem"),
    bottom: "".concat(bottom ? bottom : 4.5, "rem")
  };
  return /*#__PURE__*/_jsxs("div", {
    className: buttonClasses,
    ref: wrapperEl,
    style: style,
    children: [/*#__PURE__*/_jsx(Button, {
      onClick: onControlButtonClick,
      children: /*#__PURE__*/_jsx(Icon, {
        icon: "layers"
      })
    }), renderMenu()]
  });
};
SimpleLayersControl.propTypes = {
  activeLayerTemplateKey: PropTypes.string,
  layerTemplates: PropTypes.array,
  onSelect: PropTypes.func,
  onMount: PropTypes.func,
  opensBottom: PropTypes.bool,
  opensRight: PropTypes.bool,
  left: PropTypes.number,
  top: PropTypes.number,
  right: PropTypes.number,
  bottom: PropTypes.number
};
export default SimpleLayersControl;

// Hook
function useOnClickOutside(ref, handler) {
  useEffect(function () {
    var listener = function listener(event) {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  },
  // Add ref and handler to effect dependencies
  // It's worth noting that because passed in handler is a new ...
  // ... function on every render that will cause this effect ...
  // ... callback/cleanup to run every render. It's not a big deal ...
  // ... but to optimize you can wrap handler in useCallback before ...
  // ... passing it into this hook.
  [ref, handler]);
}